/* LUMÉA — interacciones propias (vanilla, sin librerías) */
(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Reveals al hacer scroll: un único observer compartido */
  var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function (entradas) {
    entradas.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('mt-visible'); observer.unobserve(e.target); }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }) : null;

  function initReveals(raiz) {
    raiz.querySelectorAll('.mt-reveal, .mt-hero, [data-mt-observar]').forEach(function (el) {
      if (el.dataset.mtRev) return;
      el.dataset.mtRev = '1';
      if (!observer || reducido) el.classList.add('mt-visible'); else observer.observe(el);
    });
  }

  /* Botón magnético (arquetipo 88) */
  function initMagnetico(raiz) {
    if (reducido || window.matchMedia('(hover: none)').matches) return;
    raiz.querySelectorAll('[data-mt-magnetico]').forEach(function (b) {
      if (b.dataset.mtInit) return;
      b.dataset.mtInit = '1';
      b.addEventListener('mousemove', function (ev) {
        var r = b.getBoundingClientRect();
        var x = (ev.clientX - r.left - r.width / 2) / r.width;
        var y = (ev.clientY - r.top - r.height / 2) / r.height;
        b.style.transform = 'translate(' + (x * 8).toFixed(1) + 'px,' + (y * 6).toFixed(1) + 'px)';
      });
      b.addEventListener('mouseleave', function () { b.style.transform = ''; });
    });
  }

  /* Hotspots (arquetipo 17): punto y fila de la lista sincronizados */
  function initHotspots(raiz) {
    raiz.querySelectorAll('[data-mt-hotspots]').forEach(function (s) {
      if (s.dataset.mtInit) return;
      s.dataset.mtInit = '1';
      var puntos = s.querySelectorAll('.mt-hs__punto');
      var items = s.querySelectorAll('.mt-hs__item');
      function activar(i) {
        puntos.forEach(function (p, k) { p.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
        items.forEach(function (it, k) { it.classList.toggle('mt-activo', k === i); });
      }
      puntos.forEach(function (p, i) { p.addEventListener('click', function () { activar(i); }); p.addEventListener('mouseenter', function () { activar(i); }); });
      items.forEach(function (it, i) {
        it.addEventListener('click', function () { activar(i); });
        it.addEventListener('mouseenter', function () { activar(i); });
        it.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activar(i); } });
      });
      if (puntos.length) activar(0);
    });
  }

  /* Pasos con pestañas y autoplay (arquetipo 50) */
  function initPasos(raiz) {
    raiz.querySelectorAll('[data-mt-pasos]').forEach(function (s) {
      if (s.dataset.mtInit) return;
      s.dataset.mtInit = '1';
      var tabs = s.querySelectorAll('.mt-pasos__tab');
      var imgs = s.querySelectorAll('.mt-pasos__escena img');
      var dur = parseFloat(s.dataset.duracion || '5') * 1000;
      var actual = 0, timer = null, pausa = false;
      function ir(i) {
        actual = (i + tabs.length) % tabs.length;
        tabs.forEach(function (t, k) {
          t.setAttribute('aria-selected', k === actual ? 'true' : 'false');
          var barra = t.querySelector('.mt-pasos__barra');
          if (barra) { barra.style.animation = 'none'; void barra.offsetWidth; barra.style.animation = ''; }
        });
        imgs.forEach(function (im, k) { im.classList.toggle('mt-activo', k === actual); });
        programar();
      }
      function programar() {
        clearTimeout(timer);
        if (reducido || pausa || dur <= 0) return;
        timer = setTimeout(function () { ir(actual + 1); }, dur);
      }
      tabs.forEach(function (t, i) { t.addEventListener('click', function () { pausa = true; s.classList.add('mt-pausa'); ir(i); }); });
      if (reducido || dur <= 0) s.classList.add('mt-pausa');
      ir(0);
    });
  }

  /* FAQ desplegable (arquetipo 80) */
  function initFaq(raiz) {
    raiz.querySelectorAll('.mt-faq__item').forEach(function (it) {
      if (it.dataset.mtInit) return;
      it.dataset.mtInit = '1';
      var b = it.querySelector('.mt-faq__q');
      b.addEventListener('click', function () {
        var abierto = it.classList.toggle('mt-abierto');
        b.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
    });
  }

  /* Carrusel de opiniones (arquetipo 39): flechas + avance automático con pausa */
  function initResenas(raiz) {
    raiz.querySelectorAll('[data-mt-resenas]').forEach(function (s) {
      if (s.dataset.mtInit) return;
      s.dataset.mtInit = '1';
      var pista = s.querySelector('.mt-res__pista');
      var tarjetas = pista.querySelectorAll('.mt-res__tarjeta');
      if (tarjetas.length < 2) return;
      function paso() { return tarjetas[0].getBoundingClientRect().width + parseFloat(getComputedStyle(pista).columnGap || 22); }
      function mover(dir) {
        var fin = pista.scrollLeft + pista.clientWidth >= pista.scrollWidth - 4;
        if (dir > 0 && fin) pista.scrollTo({ left: 0 }); else pista.scrollBy({ left: dir * paso() });
      }
      s.querySelectorAll('.mt-res__flecha').forEach(function (b) {
        b.addEventListener('click', function () { pausa = true; mover(parseInt(b.dataset.dir, 10)); });
      });
      var seg = parseFloat(s.dataset.autoplay || '0'), pausa = false, timer = null;
      if (reducido || seg <= 0) return;
      ['mouseenter', 'focusin', 'touchstart'].forEach(function (ev) { s.addEventListener(ev, function () { pausa = true; }, { passive: true }); });
      s.addEventListener('mouseleave', function () { pausa = false; });
      timer = setInterval(function () {
        var r = s.getBoundingClientRect();
        if (!pausa && r.bottom > 0 && r.top < window.innerHeight) mover(1);
      }, seg * 1000);
    });
  }

  /* Página de producto: galería + variantes */
  function initProducto(raiz) {
    raiz.querySelectorAll('[data-mt-producto]').forEach(function (s) {
      if (s.dataset.mtInit) return;
      s.dataset.mtInit = '1';
      var principal = s.querySelector('.mt-pp__principal img');
      var minis = s.querySelectorAll('.mt-pp__mini');
      minis.forEach(function (m) {
        m.addEventListener('click', function () {
          principal.src = m.dataset.grande;
          principal.alt = m.dataset.alt || '';
          minis.forEach(function (x) { x.setAttribute('aria-current', x === m ? 'true' : 'false'); });
        });
      });

      var datos = s.querySelector('[data-mt-variantes]');
      if (!datos) return;
      var variantes = JSON.parse(datos.textContent);
      var idInput = s.querySelector('input[name="id"]');
      var boton = s.querySelector('[data-mt-boton]');
      var precio = s.querySelector('[data-mt-precio]');
      var tachado = s.querySelector('[data-mt-tachado]');
      var aviso = s.querySelector('[data-mt-aviso]');
      var formato = s.dataset.moneda || '{{amount_with_comma_separator}} €';
      function dinero(c) {
        var v = (c / 100).toFixed(2);
        return formato.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ',')).replace(/\{\{\s*amount\s*\}\}/, v);
      }
      function elegidas() {
        return Array.prototype.map.call(s.querySelectorAll('.mt-pp__opcion'), function (f) {
          var c = f.querySelector('input:checked'); return c ? c.value : null;
        });
      }
      function actualizar() {
        var sel = elegidas();
        var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
        if (!v) { boton.disabled = true; boton.textContent = boton.dataset.noDisponible; return; }
        idInput.value = v.id;
        precio.textContent = dinero(v.price);
        if (tachado) { tachado.textContent = v.compare_at_price > v.price ? dinero(v.compare_at_price) : ''; }
        boton.disabled = !v.available;
        boton.textContent = v.available ? boton.dataset.texto : boton.dataset.agotado;
        if (aviso) aviso.textContent = v.available ? '' : aviso.dataset.agotado;
        if (v.featured_image && principal) { principal.src = v.featured_image; }
        s.querySelectorAll('.mt-pp__opcion').forEach(function (f, i) { var e = f.querySelector('[data-mt-elegido]'); if (e && sel[i]) e.textContent = sel[i]; });
        if (s.hasAttribute('data-mt-url')) { var url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url); }
      }
      s.querySelectorAll('.mt-pp__opcion input').forEach(function (i) { i.addEventListener('change', actualizar); });
    });
  }

  function initTodo(e) {
    var raiz = (e && e.target && e.target.querySelectorAll) ? e.target : document;
    initReveals(raiz); initMagnetico(raiz); initHotspots(raiz); initPasos(raiz); initFaq(raiz); initResenas(raiz); initProducto(raiz);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo); else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
